import { INITIAL_CAR_SEARCH } from '@/utils/constants';

export default function () {
  return {
    loadingMakes: false,
    loadingModels: false,
    modelList: [],
    makeList: [],
    fullVariant: {},
    selected: { ...INITIAL_CAR_SEARCH }
  };
}
